import React from "react";
import ReactDOM from "react-dom";
import { HashRouter as Router } from "react-router-dom";
import App from "./App";
import CardState from "./context/card/CardState";
import SubscribeState from "./context/subscribe/SubscribeState";
import AuthState from "./context/auth/AuthState";
import AlertState from "./context/alert/AlertState";
import ConfigState from "./context/config/ConfigState";
import CartState from "./context/cart/CartState";
import GroupState from "./context/group/GroupState";
import EmployeeState from "./context/employee/EmployeeState";
import CompCardState from "./context/comp-card/CompCardState";
import NavigationState from "./context/navigation/NavigationState";
import reportWebVitals from "./reportWebVitals";

ReactDOM.render(
  <React.StrictMode>
    <ConfigState>
      <AuthState>
        <CardState>
          <AlertState>
            <CartState>
              <SubscribeState>
                <GroupState>
                  <EmployeeState>
                    <CompCardState>
                      <NavigationState>
                        <Router>
                          <App />
                        </Router>
                      </NavigationState>
                    </CompCardState>
                  </EmployeeState>
                </GroupState>
              </SubscribeState>
            </CartState>
          </AlertState>
        </CardState>
      </AuthState>
    </ConfigState>
  </React.StrictMode>,
  document.getElementById("root")
);
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
